import type { ReactNode } from "react"
import { cn } from "@holigral/shared/ui/lib/utils"

type GoldenProps = {
  children: ReactNode
  className?: string
}

export default function Golden({ children, className }: GoldenProps) {
  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div className="flex-[0.382]" />
      {children}
      <div className="flex-[0.618]" />
    </div>
  )
}
